import PropTypes from 'prop-types';
import { useCallback } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import I18n from 'I18n';
import styled from 'styled-components';
import { getBrandStyle } from '../visitor-widget/util/color';
import IconLauncher from './IconLauncher';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const IconLauncherWrapper = styled.div.withConfig({
  displayName: "Launcher__IconLauncherWrapper",
  componentId: "sc-1az9jst-0"
})(["display:flex;align-items:center;.launcher-left-align &{flex-direction:row-reverse;}"]);
const Launcher = ({
  badgeNumber,
  coloring: {
    accentColor,
    useDefaultColor
  },
  className,
  onClose,
  onOpen,
  open,
  showBadge
}) => {
  const handleLaunch = useCallback(() => {
    if (open) {
      onClose();
    } else {
      onOpen();
    }
  }, [open, onClose, onOpen]);
  const commonProps = {
    className: classNames('reagan--widget-loaded', className),
    badgeNumber,
    showBadge,
    ariaLabel: open ? I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.close') : I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.open'),
    onClick: handleLaunch
  };
  return /*#__PURE__*/_jsx(IconLauncherWrapper, {
    children: /*#__PURE__*/_jsx(IconLauncher, Object.assign({
      style: getBrandStyle(accentColor),
      useDefaultColor: useDefaultColor,
      open: open
    }, commonProps))
  });
};
Launcher.defaultProps = {
  onOpen: emptyFunction,
  onClose: emptyFunction,
  open: false
};
Launcher.propTypes = {
  badgeNumber: PropTypes.number,
  className: PropTypes.string,
  coloring: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  showBadge: PropTypes.bool
};
Launcher.displayName = 'Launcher';
export default Launcher;